import { Component, OnInit } from '@angular/core';
import {Router, ParamMap} from '@angular/router';
import {ExcRestService} from 'exc-rest';
import {ExcSigninService} from 'exc-signin';
import {ExcTranslation} from 'exc-core';
@Component({
  selector: 'app-me',
  templateUrl: './me.component.html',
  styles: []
})
export class MeComponent extends ExcTranslation implements OnInit {

  user: {Firstname: string, Lastname: string, Provider: string, Client: string} = null;
  itemsGeneral: any[] = [];
  itemsPersonal: any[] = [];
  releaseNotes: any[] = [];
  data: {releaseNotes: any[], itemsGeneral: any[], itemsPersonal: any[]} = {itemsGeneral: [], itemsPersonal: [], releaseNotes: []};
  isLoading = true;
  sideScope = 'itemsPersonal';
  constructor(private excRest: ExcRestService, private excSec: ExcSigninService, private router: Router) {
    super();
  }

  ngOnInit() {
    this.initialLoad();
  }

  initialLoad() {
    const _self = this;
    _self.isLoading = true;
    const url = _self.excRest.computeUrl('Common_MeR_Summary');
    _self.excRest.get(url, {}).subscribe(ret => {
        _self.user = ret.User;
        _self.data.releaseNotes = ret.ReleaseNotes;
        _self.data.itemsPersonal = ret.ItemsPersonal;
        _self.data.itemsGeneral = ret.ItemsGeneral;
        _self.isLoading = false;
    });
  }
  getAccount() {
    if (this.user.Provider !== null) {
      return this.user.Provider + ' ' + this.getRessource('AccountProvider');
    }
    if (this.user.Provider !== null) {
      return this.user.Client + ' ' + this.getRessource('AccountClient');
    }
    return this.getRessource('AccountExcon');
  }
  getSalutation() {
    const h = (new Date()).getHours();
    if (h < 11) {
      return this.getRessource('SalutationMorning');
    } else if (h >= 10 && h <= 17) {
      return this.getRessource('SalutationNoon');
    } else if (h > 17) {
      return this.getRessource('SalutationEvening');
    }
  }
  getReleaseSpan(r) {
    let key = 'span_';
    key = key + (r.IsPast ? 'past_' : 'future_');
    if (r.diffMonths  > 0) {
      key = key + (r.diffMonths === 1 ? 'month' : 'months');
      return this.getRessource(key, {val: r.diffMonths});

    } else if (r.diffWeeks > 0) {
      key = key + (r.diffWeeks === 1 ? 'week' : 'weeks');
      return this.getRessource(key, {val: r.diffWeeks});

    } else {
      key = key + (r.diffDays === 1 ? 'day' : 'days');
      return this.getRessource(key, {val: r.diffDays});
    }
  }
  getReleaseStyle(r) {
    if (r.IsPast === true) {
      return {background: 'linear-gradient(270deg, rgba(24,237,77,0.3) 0%, rgba(255,255,255,0.3) 25%, rgba(255,255,255,0.3) 100%)'};
    } else {
      if (r.diffWeeks > 0) {
        return {background: 'linear-gradient(270deg, rgba(232,237,24,1) 0%, rgba(255,255,255,1) 25%, rgba(255,255,255,1) 100%)'};

      } else {
        return {background: 'linear-gradient(270deg, rgba(237,74,24,1) 0%, rgba(255,255,255,1) 25%, rgba(255,255,255,1) 100%)'};
      }
    }
  }
  openReleaseNotes(r) {
    const url = this.excRest.computeUrl('Common_MeReleaseNotesR', {riIndex: r.riIndex});
    window.open(url, '_BLANK');
  }
  openRoute(item) {
    this.router.navigate( [item.Route, {flt: item.Filter}]);
  }
}
